import React from 'react';
import t from 'prop-types';

var Unidades = function Unidades(_ref) {
  var unidades = _ref.unidades,
      onDatos = _ref.onDatos;
  return React.createElement('div', {
    className: 'opcionesAlineadas'
  }, unidades.map(function (unidad, index) {
    return React.createElement('div', {
      key: 'unidad-' + index,
      className: 'opcionUnidad' + (index + 1),
      onClick: function onClick() {
        return onDatos(unidad.datos.split(","));
      }
    });
  }));
};

Unidades.propTypes = process.env.NODE_ENV !== "production" ? {
  unidades: t.array,
  onDatos: t.func
} : {};
export default Unidades;